// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".need_help[data-v-e6f89270]{font-size:22px;line-height:26px}", ""]);
// Exports
module.exports = exports;
